import {useEffect, useRef} from 'react';

function useEffectOnlyOnUpdate(fn, inputs) {
  const didMountRef = useRef(false);

  useEffect(() => {
    if (didMountRef.current) {
      fn();
    } else {
      didMountRef.current = true;
    }
  }, inputs);
}

export {
  useEffectOnlyOnUpdate,
}
